import { useTranslation } from '@/i18n';
import { Badge } from '@/components/Shared/Badge';
import type { MatchCategory } from '@/pages/Import/logic/types';

const VARIANT: Record<MatchCategory, 'success' | 'warning' | 'info'> = {
  MATCH: 'success',
  UNSURE: 'warning',
  NEU: 'info',
};

/** Small badge for a match category (MATCH / UNSURE / NEU), with score tooltip. */
export function CategoryBadge({ category, score }: { category: MatchCategory; score?: number }) {
  const { t } = useTranslation('import');
  return (
    <Badge variant={VARIANT[category]}>
      {t(`categories.${category}`)}
      {score !== undefined && score > 0 && (
        <span className="ml-1 font-mono tabular-nums opacity-70">{score.toFixed(2)}</span>
      )}
    </Badge>
  );
}

export default CategoryBadge;
